module.exports = __webpack_public_path__ + "static/media/title_mobile.1cd46780.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/title_mobile.svg
 ** module id = 482
 ** module chunks = 0
 **/